export { default } from './Course';
export type { Props, Props as CourseMiniListingProps } from './Course';
